<template>
  <v-app>
    <v-main class="bg-grey-lighten-4">
      <AppHeader />

      <v-container fluid class="pa-8">
        <router-view />
      </v-container>

      <AppFooter />
    </v-main>
  </v-app>
</template>

<script setup>
// Importações dos componentes principais
import AppHeader from '@/components/application/AppHeader.vue';
import AppFooter from '@/components/application/AppFooter.vue';
</script>
